// IMP-479 (#569) U-40: 서버 실패 본문(rayguard-api CommonLib.RError)을 사용자 문구로 바꾸는 SSoT.
// 본문 모양: { status:'fail', errmsg:'<코드>', err:{name,message}, errors:[], data?:{ reason:'<대문자 상수>' } }
// err.message 는 서버 예외 원문일 수 있어 화면에 절대 쓰지 않는다. 문구는 사유(reason)로만 정한다.
// 라이선스 화면 전용 사유 표는 lib/licenseErrorMessages.js, 제품 이관 사유는 ProductAction 쪽을 따른다.

// 사유 → 번역키. 서버 위치는 rayguard-api src/ 기준.
export const SERVER_REASON_KEYS = {
    OUT_OF_SCOPE: 'common.message.error.reason.outOfScope', // libs/authz/writeScope.js
    NOT_SUPER_USER: 'common.message.error.reason.notSuperUser', // libs/authz/writeScope.js
    NO_TARGET: 'common.message.error.reason.noTarget', // libs/authz/writeScope.js
    STATUS_CHANGE_FORBIDDEN: 'common.message.error.reason.statusChangeForbidden', // libs/authz/serviceStatusGuard.js
    NOT_AUTHORIZED_SET_WARRANTY: 'common.message.error.reason.notAuthorizedSetWarranty', // handlers/product.js
    COMPANY_SCOPE_DENIED: 'common.message.error.reason.companyScopeDenied', // handlers/user.js
    SITE_OUT_OF_SCOPE: 'common.message.error.reason.siteOutOfScope', // handlers/product.js
    INVALID_VALUE: 'common.message.error.reason.invalidValue', // handlers/product.js (changesn)
    INSUFFICIENT_ROLE: 'common.message.error.reason.insufficientRole', // handlers/product.js (changesn)
    PARENT_COMPANY_ID_RESTRICTED: 'company.message.suOnlyFieldsReadOnly', // handlers/company.js (기존 키 재사용)
    TEMPLATE_UPDATE_CONFLICT: 'common.message.error.reason.templateUpdateConflict', // handlers/voucherTemplate.js
    COMPANY_ID_MISMATCH: 'license.error.unauthorized', // handlers/voucherTemplate.js (licenseErrorMessages 와 같은 문면)
    INVALID_EXID: 'common.message.error.reason.invalidExId', // handlers/product.js
    EXWARRANTY_NOT_FOUND: 'common.message.error.reason.exWarrantyNotFound', // handlers/product.js
    UNKNOWN_TYPE: 'common.message.error.reason.unknownType', // handlers/rayWarranty.js
};

const FAILED_KEY = 'common.message.error.processingFailed';

/**
 * 서버 실패 본문 → { message, code, errors }.
 * - code: errmsg 원본 그대로(소비처가 정확 비교하므로 가공 금지).
 * - 알려진 사유: 사유 문구 + (code). 모르는 사유: 처리 실패 + (code) + console.warn. 사유 없음: 처리 실패 + (code).
 * @param {object} body 서버 실패 본문
 * @param {(key: string) => string} t Translate
 */
export const resolveServerErrorMessage = (body, t) => {
    const code = typeof body?.errmsg === 'string' ? body.errmsg : '';
    const errors = Array.isArray(body?.errors) ? body.errors : [];
    const reason = body?.data?.reason;

    let key = FAILED_KEY;
    if (typeof reason === 'string' && reason !== '') {
        if (Object.prototype.hasOwnProperty.call(SERVER_REASON_KEYS, reason)) {
            key = SERVER_REASON_KEYS[reason];
        } else {
            console.warn('[serverErrorMessage] unmapped reason', { reason: reason.slice(0, 64), code });
        }
    }

    const base = t(key);
    return { message: code ? `${base} (${code})` : base, code, errors };
};
